import { values } from 'assets/lang';

// 格式化模型尺寸信息
const formatModelInfo = (value, keys) => {
  let info = {};
  if (!keys || /name/.test(keys)) {
    info.name = value.name || values.null;
  }
  if (!keys || /area/.test(keys)) {
    info.area = value.area == 'Infinity' ? values.disdata : (parseFloat((value.area || '0').replace(/[^\d.-]/g, '')) / 100).toFixed(2).toString().replace('0.00', values.null);
  }
  if (!keys || /volume/.test(keys)) {
    info.volume = value.volume == 'Infinity' ? values.disdata : (parseFloat((value.volume || '0').replace(/[^\d.-]/g, '')) / 1000).toFixed(2).toString().replace('0.00', values.null);
  }
  if (!keys || /size/.test(keys)) {
    info.size = value.size == 'Infinity' ? values.disdata : (value.size || values.null).replace(new RegExp('[^\\d.~\\-*' + values.multiply + ']', 'gi'), '');
  }
  return info;
};

const isMobile = () => {
  let u = navigator.userAgent;
  if (!!u.match(/AppleWebKit.*Mobile.*/)) {
    return true;
  } else {
    return false;
  }
};

export {
  formatModelInfo,
  isMobile
};



// WEBPACK FOOTER //
// ./src/plugins/Methods.js